/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as AppIndexRouteImport } from "./routes/_app.index"
import { Route as LoginResetRouteImport } from "./routes/login.reset"
import { Route as AppTeamRouteImport } from "./routes/_app.team"
import { Route as AppSettingsRouteImport } from "./routes/_app.settings"
import { Route as AppSandboxRouteImport } from "./routes/_app.sandbox"
import { Route as AppMaturityRouteImport } from "./routes/_app.maturity"
import { Route as AppMapRouteImport } from "./routes/_app.map"
import { Route as AppCmmsRouteImport } from "./routes/_app.cmms"
import { Route as AppAssetsV2RouteImport } from "./routes/_app.assets-v2"
import { Route as AppAssetsRouteImport } from "./routes/_app.assets"
import { Route as AppAskReliRouteImport } from "./routes/_app.ask-reli"
import { Route as AppAchievementsRouteImport } from "./routes/_app.achievements"
import { Route as AppFacilitiesFacilityIdRouteImport } from "./routes/_app.facilities.$facilityId"

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const LoginResetRoute = LoginResetRouteImport.update({
  id: "/login/reset",
  path: "/login/reset",
  getParentRoute: () => rootRouteImport,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: "/team",
  path: "/team",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any)
const AppSandboxRoute = AppSandboxRouteImport.update({
  id: "/sandbox",
  path: "/sandbox",
  getParentRoute: () => AppRoute,
} as any)
const AppMaturityRoute = AppMaturityRouteImport.update({
  id: "/maturity",
  path: "/maturity",
  getParentRoute: () => AppRoute,
} as any)
const AppMapRoute = AppMapRouteImport.update({
  id: "/map",
  path: "/map",
  getParentRoute: () => AppRoute,
} as any)
const AppCmmsRoute = AppCmmsRouteImport.update({
  id: "/cmms",
  path: "/cmms",
  getParentRoute: () => AppRoute,
} as any)
const AppAssetsV2Route = AppAssetsV2RouteImport.update({
  id: "/assets-v2",
  path: "/assets-v2",
  getParentRoute: () => AppRoute,
} as any)
const AppAssetsRoute = AppAssetsRouteImport.update({
  id: "/assets",
  path: "/assets",
  getParentRoute: () => AppRoute,
} as any)
const AppAskReliRoute = AppAskReliRouteImport.update({
  id: "/ask-reli",
  path: "/ask-reli",
  getParentRoute: () => AppRoute,
} as any)
const AppAchievementsRoute = AppAchievementsRouteImport.update({
  id: "/achievements",
  path: "/achievements",
  getParentRoute: () => AppRoute,
} as any)
const AppFacilitiesFacilityIdRoute = AppFacilitiesFacilityIdRouteImport.update({
  id: "/facilities/$facilityId",
  path: "/facilities/$facilityId",
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  "/achievements": typeof AppAchievementsRoute
  "/ask-reli": typeof AppAskReliRoute
  "/assets": typeof AppAssetsRoute
  "/assets-v2": typeof AppAssetsV2Route
  "/cmms": typeof AppCmmsRoute
  "/map": typeof AppMapRoute
  "/maturity": typeof AppMaturityRoute
  "/sandbox": typeof AppSandboxRoute
  "/settings": typeof AppSettingsRoute
  "/team": typeof AppTeamRoute
  "/login/reset": typeof LoginResetRoute
  "/": typeof AppIndexRoute
  "/facilities/$facilityId": typeof AppFacilitiesFacilityIdRoute
}
export interface FileRoutesByTo {
  "/achievements": typeof AppAchievementsRoute
  "/ask-reli": typeof AppAskReliRoute
  "/assets": typeof AppAssetsRoute
  "/assets-v2": typeof AppAssetsV2Route
  "/cmms": typeof AppCmmsRoute
  "/map": typeof AppMapRoute
  "/maturity": typeof AppMaturityRoute
  "/sandbox": typeof AppSandboxRoute
  "/settings": typeof AppSettingsRoute
  "/team": typeof AppTeamRoute
  "/login/reset": typeof LoginResetRoute
  "/": typeof AppIndexRoute
  "/facilities/$facilityId": typeof AppFacilitiesFacilityIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/_app/achievements": typeof AppAchievementsRoute
  "/_app/ask-reli": typeof AppAskReliRoute
  "/_app/assets": typeof AppAssetsRoute
  "/_app/assets-v2": typeof AppAssetsV2Route
  "/_app/cmms": typeof AppCmmsRoute
  "/_app/map": typeof AppMapRoute
  "/_app/maturity": typeof AppMaturityRoute
  "/_app/sandbox": typeof AppSandboxRoute
  "/_app/settings": typeof AppSettingsRoute
  "/_app/team": typeof AppTeamRoute
  "/login/reset": typeof LoginResetRoute
  "/_app/": typeof AppIndexRoute
  "/_app/facilities/$facilityId": typeof AppFacilitiesFacilityIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/achievements"
    | "/ask-reli"
    | "/assets"
    | "/assets-v2"
    | "/cmms"
    | "/map"
    | "/maturity"
    | "/sandbox"
    | "/settings"
    | "/team"
    | "/login/reset"
    | "/"
    | "/facilities/$facilityId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/achievements"
    | "/ask-reli"
    | "/assets"
    | "/assets-v2"
    | "/cmms"
    | "/map"
    | "/maturity"
    | "/sandbox"
    | "/settings"
    | "/team"
    | "/login/reset"
    | "/"
    | "/facilities/$facilityId"
  id:
    | "__root__"
    | "/_app"
    | "/_app/achievements"
    | "/_app/ask-reli"
    | "/_app/assets"
    | "/_app/assets-v2"
    | "/_app/cmms"
    | "/_app/map"
    | "/_app/maturity"
    | "/_app/sandbox"
    | "/_app/settings"
    | "/_app/team"
    | "/login/reset"
    | "/_app/"
    | "/_app/facilities/$facilityId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginResetRoute: typeof LoginResetRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/login/reset": {
      id: "/login/reset"
      path: "/login/reset"
      fullPath: "/login/reset"
      preLoaderRoute: typeof LoginResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/team": {
      id: "/_app/team"
      path: "/team"
      fullPath: "/team"
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings": {
      id: "/_app/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/sandbox": {
      id: "/_app/sandbox"
      path: "/sandbox"
      fullPath: "/sandbox"
      preLoaderRoute: typeof AppSandboxRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/maturity": {
      id: "/_app/maturity"
      path: "/maturity"
      fullPath: "/maturity"
      preLoaderRoute: typeof AppMaturityRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/map": {
      id: "/_app/map"
      path: "/map"
      fullPath: "/map"
      preLoaderRoute: typeof AppMapRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/cmms": {
      id: "/_app/cmms"
      path: "/cmms"
      fullPath: "/cmms"
      preLoaderRoute: typeof AppCmmsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/assets-v2": {
      id: "/_app/assets-v2"
      path: "/assets-v2"
      fullPath: "/assets-v2"
      preLoaderRoute: typeof AppAssetsV2RouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/assets": {
      id: "/_app/assets"
      path: "/assets"
      fullPath: "/assets"
      preLoaderRoute: typeof AppAssetsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/ask-reli": {
      id: "/_app/ask-reli"
      path: "/ask-reli"
      fullPath: "/ask-reli"
      preLoaderRoute: typeof AppAskReliRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/achievements": {
      id: "/_app/achievements"
      path: "/achievements"
      fullPath: "/achievements"
      preLoaderRoute: typeof AppAchievementsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/facilities/$facilityId": {
      id: "/_app/facilities/$facilityId"
      path: "/facilities/$facilityId"
      fullPath: "/facilities/$facilityId"
      preLoaderRoute: typeof AppFacilitiesFacilityIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAchievementsRoute: typeof AppAchievementsRoute
  AppAskReliRoute: typeof AppAskReliRoute
  AppAssetsRoute: typeof AppAssetsRoute
  AppAssetsV2Route: typeof AppAssetsV2Route
  AppCmmsRoute: typeof AppCmmsRoute
  AppMapRoute: typeof AppMapRoute
  AppMaturityRoute: typeof AppMaturityRoute
  AppSandboxRoute: typeof AppSandboxRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTeamRoute: typeof AppTeamRoute
  AppIndexRoute: typeof AppIndexRoute
  AppFacilitiesFacilityIdRoute: typeof AppFacilitiesFacilityIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAchievementsRoute: AppAchievementsRoute,
  AppAskReliRoute: AppAskReliRoute,
  AppAssetsRoute: AppAssetsRoute,
  AppAssetsV2Route: AppAssetsV2Route,
  AppCmmsRoute: AppCmmsRoute,
  AppMapRoute: AppMapRoute,
  AppMaturityRoute: AppMaturityRoute,
  AppSandboxRoute: AppSandboxRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTeamRoute: AppTeamRoute,
  AppIndexRoute: AppIndexRoute,
  AppFacilitiesFacilityIdRoute: AppFacilitiesFacilityIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginResetRoute: LoginResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
